module.exports = __webpack_public_path__ + "img/HQ-ENC-V1_ALL.4c09d7f3.jpg";